export interface TestimonialImage {
  src: string;
  alt: string;
}

export const testimonialImages: TestimonialImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/fWyUgDS1xctXHWyaKErAZQ/Imagen_de_ChatGPT_27_sept_2026,_15_03_06.webp',
    alt: 'Mensaje de Laura Fernández contando que el material le está ahorrando tiempo de preparación y le gusta tener el montaje, los tiempos y las correcciones de cada tarea.'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/sG1rNcZ3Vnf6N9fEKWCDnr/Imagen_de_ChatGPT_27_sept_2026,_15_03_45.webp',
    alt: 'Mensaje de Diego Morales explicando que usa sobre todo las sesiones ya preparadas y valora que estén organizadas por niveles N1, N2 y N3.'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cJudynn5iovQZDjoqUH9ja/Imagen_de_ChatGPT_27_sept_2026,_15_04_52.webp',
    alt: 'Publicación de Instagram de un entrenador comentando que las sesiones express de 15 minutos son lo que más está usando cuando hay poco tiempo.'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/beCgBYuysnT1nW5FYe8bxr/Imagen_de_ChatGPT_27_sept_2026,_15_05_55.webp',
    alt: 'Publicación de Carlos Ramírez sobre la parte táctica del sistema: recepción, defensa, K1 y K2, cobertura y reconstrucción, organizadas por niveles.'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/txbFcsjRZKqpbYT4xSnGsL/Imagen_de_ChatGPT_27_sept_2026,_15_06_50.webp',
    alt: 'Correo de Marta Sánchez explicando que el mapa de temporada le da una progresión clara a lo largo de las 40 semanas, adaptándose al ritmo del equipo.'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/si2kXYm1abM4RX1QSPmnFj/Imagen_de_ChatGPT_27_sept_2026,_15_08_00.webp',
    alt: 'Mensaje de Javi Ortega sobre el tomo de técnica individual: las 64 fichas con objetivo, montaje, desarrollo, observación y corrección rápida.'
  }
];
